import React from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { ImagePreview } from "utils/imagePreviewURLConverter";
import { addBannerApi } from "services/banner-management";
import { toastMessage } from "utils/toastMessage";

const AddBanner = ({
  addBannerState,
  bannerMgmtApiCall,
  closeModel,
  position,
}) => {
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");
  const [imgInputState, setImageInputState] = useState("");
  // -------image preview related state
  const [imgPreviewState, seImgPreviewState] = useState(null);

  // ✅ ADDED: POSITION TO DIMENSION MAPPING
  const dimensionMap = {
    1: { width: 1050, height: 459 },
    2: { width: 1053, height: 300 },
    3: { width: 768, height: 330 },
    4: { width: 1050, height: 330 },
    5: { width: 768, height: 330 },
  };
  const expectedDim = dimensionMap[position];
  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!imgInputState.length) {
      errorObject["imgEmptyErrorMsg"] = "Image is not Set";
      status = false;
    }

    setError(errorObject);

    return status;
  };

  // Add Brand close modal
  const addBrandCloseModal = () => {
    setImageInputState("");
    setError({});
    bannerMgmtApiCall();
    closeModel();
  };

  // Add Brand handler
  const addBannerHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          image: imgInputState,
          position: position,
        };

        const { data } = await addBannerApi(dataToSend);
        if (data.status || data.code === 200) {
          addBrandCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  // const imgUploadFunction = async (e) => {
  //   if (!e?.target?.files[0]?.type.includes("image/")) {
  //     setError((stateProp) => ({
  //       ...stateProp,
  //       imgErrorOccur: "Please Choose Image file not others",
  //     }));
  //   } else {
  //     try {
  //       const data = await imgUploadToCloudFun(e?.target?.files[0]);
  //       // console.log("1st data?.data[0]:-------->", data?.data[0]);
  //       if (data?.status === 200) {
  //         //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
  //         setImageInputState(data?.data[0]);
  //         seImgPreviewState(e?.target?.files[0]);
  //       }
  //     } catch (error) {
  //       console.log("error while uploading and getting data", error);
  //     }
  //   }
  // };
  // ✅ CHANGED: IMG UPLOAD FUNCTION WITH DIMENSION VALIDATION + TOAST
  const imgUploadFunction = async (e) => {
    const file = e?.target?.files[0];

    if (!file?.type.includes("image/")) {
      toastMessage("Please choose a valid image file.", "error", "invalidImage");
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = async function () {
      const expectedDim = dimensionMap[position];

      // if (
      //   img.width !== expectedDim.width ||
      //   img.height !== expectedDim.height
      // ) {
      //   toastMessage(
      //     `Invalid image dimensions.\nRequired: ${expectedDim.width}x${expectedDim.height}px\nUploaded: ${img.width}x${img.height}px`,
      //     "error",
      //     "invalidDimension"
      //   );
      //   // ✅ Clear file input, preview, and URL
      //   e.target.value = ""; // clear input field
      //   setImageInputState(""); // clear URL
      //   seImgPreviewState(null); // clear preview
      //   setError({})
      //   URL.revokeObjectURL(objectUrl);
      //   return;
      // }

      try {
        const data = await imgUploadToCloudFun(file);
        if (data?.status === 200) {
          setImageInputState(data?.data[0]);
          seImgPreviewState(file);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }

      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };
  return (
    <CustomModal
      className={"add_model"}
      show={addBannerState}
      handleClose={addBrandCloseModal}
    >
      <h3>Add {position} Banner</h3>
      <div className="form_field">
        <label htmlFor=""><span className="text-danger">*</span>Upload image size <b>{expectedDim.width}x{expectedDim.height}px</b></label>
        <input
          onChange={imgUploadFunction}
          type="file"
          accept="image/*"
          className="form-control"
        />

        {!imgInputState.length && error["imgEmptyErrorMsg"] && (
          <span className="red-color">{error["imgEmptyErrorMsg"]}</span>
        )}
        {/* {error["imgErrorOccur"] && (
          <p className="red-color">{error["imgErrorOccur"]}</p>
        )} */}
        {/* ------image preview Container div */}
        <div className="image_preview">{<ImagePreview file={imgPreviewState} />}</div>
      </div>


      {/* ----end of img preview component */}

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBrandCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={addBannerHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default AddBanner;
